var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from '../common/Modal';
import regEx from '../../utils/regex';
import { getContentType } from './content-helpers';
import { List, ListItemInput, ListItemSelect, ListItemSwitch, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
import { refetchContentListQuery, useCreateContentMutation, useCreateContentPageQuery, } from '../../__generated__/graphql';
export default function CreateContentModal(props) {
    // GraphQL query
    var data = useCreateContentPageQuery().data;
    // State
    var _a = useState(''), label = _a[0], setLabel = _a[1];
    var _b = useState(''), title = _b[0], setTitle = _b[1];
    var _c = useState(''), description = _c[0], setDescription = _c[1];
    var _d = useState(''), url = _d[0], setUrl = _d[1];
    var _e = useState(''), previewUrl = _e[0], setPreviewUrl = _e[1];
    var _f = useState(''), imageUrl = _f[0], setImageUrl = _f[1];
    var _g = useState(''), eventId = _g[0], setEventId = _g[1];
    var _h = useState(false), isPublic = _h[0], setIsPublic = _h[1];
    // GraphQL mutation
    var createContent = useCreateContentMutation({
        variables: {
            input: {
                label: label.trim(),
                title: title.trim(),
                description: description.trim(),
                url: url.trim(),
                previewUrl: previewUrl ? previewUrl.trim() : null,
                imageUrl: imageUrl.trim() || undefined,
                type: getContentType(url.trim()),
                eventId: eventId === '' ? null : eventId,
                public: isPublic,
                hasCategories: [],
            },
        },
        refetchQueries: [refetchContentListQuery()],
    })[0];
    // Events
    var noEvent = { id: '', name: 'No event' };
    var storedEvents = (data === null || data === void 0 ? void 0 : data.events) || [];
    var events = __spreadArrays([noEvent], storedEvents);
    var disabled = !label ||
        (label && regEx.trimmedString.test(label.trim())) === false ||
        label.trim().length > 100 ||
        label.trim().length < 1 ||
        !title ||
        (title && regEx.trimmedString.test(title.trim())) === false ||
        title.trim().length > 100 ||
        title.trim().length < 1 ||
        !description ||
        description.trim().length > 1000 ||
        // Note: The textInput will only accept 1000 characters and cut the text after 1000 char.
        // Consequently the disable function will not be utilized as long as
        // a supported browser is used, and the HTMLInputElement is displayed as expected.
        description.trim().length < 1 ||
        !url ||
        url.trim().length > 1000 ||
        !regEx.url.test(url.trim()) ||
        imageUrl.trim().length > 1000 ||
        (imageUrl && regEx.url.test(imageUrl)) === false ||
        previewUrl.trim().length > 1000 ||
        (previewUrl && regEx.url.test(previewUrl)) === false;
    // Event handlers
    var confirm = function () {
        void createContent();
        setLabel('');
        setTitle('');
        setDescription('');
        setUrl('');
        setImageUrl('');
        setEventId('');
        props.onCancel();
    };
    var cancel = function () {
        setLabel('');
        setTitle('');
        setDescription('');
        setUrl('');
        setImageUrl('');
        setEventId('');
        props.onCancel();
    };
    return (_jsx(Modal, __assign({ "data-test": "modal-create-content", title: "Create Content", open: props.open, onCancel: cancel, onConfirm: confirm, disabled: disabled }, { children: _jsxs(List, { children: [_jsx(ListItemInput, { type: "text", label: "Label", value: label, onChange: setLabel, placeholder: "My event series" }, void 0),
                _jsx(ListItemInput, { type: "text", label: "Title", value: title, onChange: setTitle, placeholder: "Keynote speaker" }, void 0),
                _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription, placeholder: "Video of the year" }, void 0),
                _jsx(ListItemInput, { type: "text", label: "URL", value: url, onChange: setUrl, placeholder: "https://vimeo.com/412427615" }, void 0),
                _jsx(ListItemInput, { type: "text", label: "URL for image", value: imageUrl, onChange: setImageUrl, placeholder: "https://i.vimeocdn.com/video/885418825_640.jpg" }, void 0),
                _jsx(ListItemSelect, { label: "Event", value: eventId, onChange: setEventId, options: events }, void 0),
                _jsx(ListItemSwitch, { primary: "Public", wrapPrimary: true, checked: isPublic, onClick: function () { return setIsPublic(!isPublic); } }, void 0),
                _jsx(ListItemInput, { type: "text", label: "Preview URL", value: previewUrl || '', onChange: setPreviewUrl }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=CreateContentModal.js.map